<template>
  <router-link
    v-if="displayLink"
    :to="hashTag"
    :class="buttonClass"
  >{{ buttonText }}</router-link>
  <a
    v-else
    :href="linkBtn"
    target="_blank"
    rel="noopener noreferrer"
    :class="buttonClass"
  >{{ buttonText }}</a>
</template>

<script>
export default {
  name: 'ButtonComp',
  props: {
    buttonText: {
      type: String,
      default: 'Learn More',
    },
    btnColor: {
      type: String,
      default: 'btn-primary',
    },
    linkBtn: {
      type: String,
      default: '/',
    },
    hashTag: {
      type: String,
      default: '#',
    },
    displayLink: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    buttonClass() {
      return `${this.btnColor} btn`
    },
  },
}
</script>
